import script from "./Step0CensusType.vue?vue&type=script&setup=true&lang=js"
export * from "./Step0CensusType.vue?vue&type=script&setup=true&lang=js"

import "./Step0CensusType.vue?vue&type=style&index=0&id=389432d0&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-389432d0"]])

export default __exports__